import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { SelectField } from "@/lib/crm";
import { PaymentFields } from "@/components/sales/PaymentFields";
import { isQualifyError, qualifyThen } from "@/components/crm/QualifyHost";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const plus30 = () => new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10);

export const NewQuoteDialog = ({ open, onOpenChange, opportunity, companyId }) => {
  const nav = useNavigate();
  const [opps, setOpps] = useState([]);
  const [f, setF] = useState({ opportunity_id: "", title: "", valid_until: plus30(), payment_terms: null, deposit_pct: null });
  useEffect(() => {
    if (!open) return;
    setF({ opportunity_id: opportunity?.id || "", title: opportunity?.title || "", valid_until: plus30(), payment_terms: null, deposit_pct: null });
    if (!opportunity) api.get("/sales/opportunities", { params: { status: "open", limit: 100, sort: "title", dir: "asc", ...(companyId ? { company_id: companyId } : {}) } })
      .then((r) => setOpps(r.data.items.map((o) => ({ id: o.id, name: `${o.title} — ${o.company_name}`, title: o.title })))).catch(() => setOpps([]));
  }, [open, opportunity, companyId]);

  const save = async () => {
    try {
      const r = await api.post("/sales/quotes", { opportunity_id: f.opportunity_id, title: f.title.trim(), valid_until: f.valid_until || null, payment_terms: f.payment_terms, deposit_pct: f.deposit_pct, lines: [] });
      toast.success(`Offerta ${r.data.number} creata`); onOpenChange(false); nav(`/offerte/${r.data.id}`);
    } catch (e) {
      if (isQualifyError(e)) { if (await qualifyThen(e, f.opportunity_id)) save(); return; }
      toast.error(errorMessage(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="new-quote-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Nuova offerta</DialogTitle>
          <DialogDescription>Il numero (OFF-AAAA-NNNN) viene assegnato automaticamente. Le righe si aggiungono subito dopo.</DialogDescription></DialogHeader>
        <div className="space-y-4 py-2">
          {opportunity ? <div><Label className="text-xs">Opportunità</Label><p className="mt-1 text-sm font-semibold text-ink">{opportunity.title}</p></div>
            : <SelectField label="Opportunità" value={f.opportunity_id} onChange={(v) => setF({ ...f, opportunity_id: v, title: f.title || opps.find((o) => o.id === v)?.title || "" })} options={opps} testId="new-quote-opportunity" />}
          <div className="space-y-1.5"><Label className="text-xs">Oggetto</Label><Input maxLength={200} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="new-quote-title" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Valida fino al</Label><Input type="date" value={f.valid_until} onChange={(e) => setF({ ...f, valid_until: e.target.value })} data-testid="new-quote-valid" /></div>
          <PaymentFields f={f} setF={(p) => setF((x) => ({ ...x, ...p }))} testPrefix="new-quote" />
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button onClick={save} disabled={!f.opportunity_id || f.title.trim().length < 2} data-testid="new-quote-save">Crea bozza</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
